import React, { useState, useEffect, useReducer } from "react";

import {
  Box,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Grid,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

import TooltipIndicators from "../../../Dash/Tooltip";
import Typography from "../../../Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import defaultReducer from "../../../../utils/defaultReducer";
import api from "../../../../api";
import { getSession } from "../../../../auth";

import dayjs from "dayjs";

const enterprise = getSession()?.profile.enterprise;

import "./styles.css";

const SideBarData = ({
  messages,
  conversationType,
  sentiment,
  products,
  summary,
}) => {
  return (
    <Box className="vertical">
      <Grid container spacing={2} className="analytics-container">
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box fullWidth>
            <Box className="dash-centralizer">
              <Box>
                <Box className="fontSize-title">
                  <Typography
                    align="center"
                    text="Mensagens"
                    color="darkGray"
                    fontWeight="500"
                    variant="subtitle1"
                  />
                </Box>
                <Box className="analytics-values analytics-indicator">
                  {messages}
                </Box>
              </Box>
            </Box>
            {/* <TooltipIndicators text="Total de mensagens trocadas." /> */}
          </Box>{" "}
        </Grid>
        {conversationType === "CONTACT" && (
          <Grid item lg={12} md={12} sm={12} xs={12} fullWidth>
            <Box fullWidth>
              <Box className="dash-centralizer">
                <Box>
                  <Box className="fontSize-title">
                    <Typography
                      align="center"
                      text="Satisfação"
                      color="darkGray"
                      fontWeight="500"
                      variant="subtitle1"
                    />
                  </Box>
                  <Box className="analytics-values analytics-indicator">
                    {sentiment}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box fullWidth>
            <Box className="dash-centralizer">
              <Box>
                <Box className="fontSize-title">
                  <Typography
                    align="center"
                    text="Produtos"
                    color="darkGray"
                    fontWeight="500"
                    variant="subtitle1"
                  />
                </Box>
                <Box className="analytics-products">
                  {products && products.length > 0
                    ? products.join(", ")
                    : "Nenhum produto ou serviço mencionado."}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box fullWidth>
            <Box className="dash-centralizer">
              <Box>
                <Box className="fontSize-title">
                  <Typography
                    align="center"
                    text="Resumo"
                    color="darkGray"
                    fontWeight="500"
                    variant="subtitle1"
                  />
                </Box>
                <Box className="analytics-longform">
                  {summary || "Nenhum resumo disponível."}
                </Box>
              </Box>
            </Box>
            {/* <TooltipIndicators text="Resumo da conversa ." /> */}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const NoData = ({ noDataMessage }) => {
  return (
    <Box className="no-data-message">
      <Typography
        align="center"
        text={noDataMessage}
        color="darkGray"
        fontWeight="500"
        variant="subtitle1"
      />
    </Box>
  );
};

const AnalyticsSideBar = ({
  analyticsDate,
  accountId,
  conversationId,
  conversationType,
  setParent,
}) => {
  const [state, setState] = useReducer(defaultReducer, {
    messages: 0,
    sentiment: 0,
    products: [],
    summary: "",
    noData: false,
    noDataMessage: "",
  });
  useEffect(async () => {
    const d = await api.get(
      `api/enterprises/${enterprise.id}/scout_analytics/conversation/?date=${analyticsDate}&account_id=${accountId}&conversation_id=${conversationId}`
    );
    if (d.status === 200) {
      setState({
        messages: d.data.messages || 0,
        sentiment: d.data.sentiment || 0,
        products: d.data.products || [],
        summary: d.data.summary || "",
        noData: false,
        noDataMessage: "",
      });
    } else {
      let noDataMessage = "Erro ao buscar dados do dashboard.";
      if (d.status === 204) {
        const today = dayjs().format("YYYY-MM-DD");
        if (analyticsDate === today) {
          noDataMessage = "Dados de hoje ainda em processamento.";
        } else {
          noDataMessage = "Nenhum dado disponível para a data selecionada.";
        }
      }
      setState({
        messages: 0,
        sentiment: 0,
        products: [],
        summary: "",
        noData: true,
        noDataMessage: noDataMessage,
      });
    }
  }, [analyticsDate, accountId, conversationId]);

    return (
      <Box className="chat-right-sidebar" style={{ height: "100%" }}>
        <Accordion expanded={true} className="accordion">
          <AccordionSummary
            className="accordionHeader"
            onClick={() =>
              setParent({
                showCRMSidebar: false,
                showAnalyticsSidebar: false,
                showSearch: false,
              })
            }
          >
            <IconButton className="contactHistory-iconButton">
              <ChevronRightIcon />
            </IconButton>
            {`Análise Cortex (${analyticsDate})`}
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            {state.noData ? (
              <NoData noDataMessage={state.noDataMessage} />
            ) : (
              <SideBarData
                messages={state.messages}
                conversationType={conversationType}
                sentiment={state.sentiment}
                products={state.products}
                summary={state.summary}
              />
            )}
          </AccordionDetails>
        </Accordion>
      </Box>
    );
};

export default AnalyticsSideBar;
